/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GeoTestScheduleDTO { 
    startDate: string;
    endDate: string;
    testLength: number;
    testType: GeoTestScheduleDTO.TestTypeEnum;
    mde: number;
    inventoryRefStartDate?: string;
    inventoryRefEndDate?: string;
}
export namespace GeoTestScheduleDTO {
    export type TestTypeEnum = 'Holdout' | 'Scale' | 'Contribution';
    export const TestTypeEnum = {
        Holdout: 'Holdout' as TestTypeEnum,
        Scale: 'Scale' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
}


